import type { ButtonHTMLAttributes, ReactNode } from "react";
import { LinkInterno } from "../navegacao";

export type PropsBotao = ButtonHTMLAttributes<HTMLButtonElement> & {
  variante?: "primario" | "secundario" | "fantasma" | "perigo";
  tamanho?: "normal" | "pequeno";
  largo?: boolean;
  carregando?: boolean;
  icone?: ReactNode;
};

export function Botao({ variante = "primario", tamanho = "normal", largo, carregando, icone, children, className, disabled, type = "button", ...p }: PropsBotao) {
  const classes = ["mtc-botao", `mtc-botao--${variante}`, tamanho === "pequeno" && "mtc-botao--pequeno", largo && "mtc-botao--largo", className].filter(Boolean).join(" ");
  return (
    <button type={type} className={classes} disabled={disabled || carregando} aria-busy={carregando || undefined} {...p}>
      {carregando ? <span className="mtc-giro" aria-hidden /> : icone}
      {children}
    </button>
  );
}

/** Link com cara de botao (navega; nao faz acao). Usa o link do roteador do app. */
export function BotaoLink({ href, variante = "secundario", tamanho = "normal", icone, children }: { href: string; variante?: PropsBotao["variante"]; tamanho?: PropsBotao["tamanho"]; icone?: ReactNode; children: ReactNode }) {
  return <LinkInterno href={href} className={["mtc-botao", `mtc-botao--${variante}`, tamanho === "pequeno" && "mtc-botao--pequeno"].filter(Boolean).join(" ")}>{icone}{children}</LinkInterno>;
}
